import { create } from '@signals/app-shell/shims/zustand';
import * as itineraryApi from '../services/itineraryApi';

interface StudentProfileState {
  studentNumber: string;
  gender: string;
  height: string;
  weight: string;
  hairTypeColor: string;
  facialHairTypeColor: string;
  vehMake: string;
  vehModel: string;
  vehColor: string;
  vehPlate: string;
  profileVersion: number;
  syncProfile: (profile: itineraryApi.StudentProfile) => void;
  clearAllProfiles: () => void;
}

export const useStudentProfileStore = create<StudentProfileState>((set) => ({
  studentNumber: '',
  gender: '',
  height: '',
  weight: '',
  hairTypeColor: '',
  facialHairTypeColor: '',
  vehMake: '',
  vehModel: '',
  vehColor: '',
  vehPlate: '',
  profileVersion: 0,
  syncProfile: (profile) => set((state) => ({
    studentNumber: profile.student_number || '',
    gender: profile.gender || '',
    height: profile.height || '',
    weight: profile.weight || '',
    hairTypeColor: profile.hair_typecolor || '',
    facialHairTypeColor: profile.facial_hair_typecolor || '',
    vehMake: profile.veh_make || '',
    vehModel: profile.veh_model || '',
    vehColor: profile.veh_color || '',
    vehPlate: profile.veh_plate || '',
    profileVersion: state.profileVersion + 1,
  })),
  clearAllProfiles: () => set((state) => ({
    studentNumber: '',
    gender: '',
    height: '',
    weight: '',
    hairTypeColor: '',
    facialHairTypeColor: '',
    vehMake: '',
    vehModel: '',
    vehColor: '',
    vehPlate: '',
    profileVersion: state.profileVersion + 1,
  })),
}));
